// contract.interface.ts
export enum ContractState {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED'
}

export enum LanguageCode {
  EN = 'en',
  IT = 'it',
}

export interface ContractTranslation {
  locale: LanguageCode;
  fileKey: string;
}

export interface Contract {
  id?: string;
  title: string;
  version: number;
  state: ContractState;
  note?: string;
  translation: ContractTranslation;
  translations?: Record<LanguageCode, ContractTranslation>;
  publishedAt?: Date;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface CreateContractRequest {
  title: string;
  note?: string;
  translation: {
    locale: string;
    fileKey: string;
  };
  translations?: Record<string, string>; // Map of locale to fileKey
}

export interface UpdateContractRequest {
  title?: string;
  note?: string;
  translation?: {
    locale: string;
    fileKey: string;
  };
  translations?: Record<string, string>; // Map of locale to fileKey
}

export interface ContractResponse {
  totalCount: number;
  paginationInfo: {
    hasNext: boolean;
    page: number;
    size: number;
    count: number;
  };
  items: Contract[];
}

export interface PaginationQuery {
  page?: number;
  size?: number;
  getTotalCount?: boolean;
  state?: ContractState;
}
